export const filterModalCategory = (onChangeCategoryFunc) => {
  // カテゴリボタンにそれぞれonclickを登録
  const buttons = document.querySelectorAll('.js-filter-modal-category');
  buttons.forEach((element) => {
    element.addEventListener('click', () => {
      onChangeCategoryFunc(element);
    });
  });
};

export const filterModalGenre = (onChangeGenreFunc) => {
  // ジャンルボタンにそれぞれonclickを登録
  const buttons = document.querySelectorAll('.js-filter-modal-genre');
  buttons.forEach((element) => {
    element.addEventListener('click', () => {
      onChangeGenreFunc(element);
    });
  });
};
